<template>
    <div class="login_content" :style="{backgroundImage: 'url(' + bgimg + ')'}">
        <div class="login_box">
            <div class="login_clear clear">
                <div class="register_logo"><img :src="logoimg" alt="logo" /></div>
                <div class="register_content">
                    <div class="register_title"><h2>设置密码</h2></div>
                    <div class="register_list">
                        <Form ref="passwordValidate" :model="passwordValidate" :rules="passwordRule">
                            <FormItem prop="passwords">
                                <Input type="password" :minlength="6" :maxlength="20" v-model="passwordValidate.passwords" placeholder="设置密码 (6-20位，英文、符号)" />
                            </FormItem>
                            <FormItem prop="passwordcheck">
                                <Input type="password" :minlength="6" :maxlength="20" v-model="passwordValidate.passwordcheck" placeholder="确认密码" />
                            </FormItem>
                            <FormItem>
                                <Button class="register_submit" type="warning" long @click="handleSubmit('passwordValidate')">完成</Button>
                            </FormItem>
                        </Form>
                    </div>
                </div>
                <div class="login_copyright_content"><span>{{tcpip}}</span></div>
            </div>
        </div>
        <!-- 漂浮客服 -->
        <ServerFixed></ServerFixed>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import qs from 'Qs'
import ServerFixed from '@/components/component/serverfixed.vue'

export default {
    components: {ServerFixed},
    data () {
        const passwordsValidator = (rule, value, callback) => { // 密码
            var reg = new RegExp("[\\u4E00-\\u9FFF]+","g")
            if (value === '' || value.length < 6 || value.length > 20 || reg.test(value)) {
                if (value === '') {
                    callback(new Error('密码不可为空，请填写'));
                } else {
                    callback(new Error('请输入6-20位英文、数字、符号（如$、*、%...）'));
                }
                callback(new Error(''));
            } else {
                if (this.passwordValidate.passwordcheck != '') {
                    // 对第二个密码框单独验证
                    this.$refs.passwordValidate.validateField('passwordcheck');
                }
                callback();
            }
        }
        const passwordcheckValidator = (rule, value, callback) => { // 确认密码
            if (value === '') {
                callback(new Error('确认密码不可为空，请填写'));
            } else if (value !== this.passwordValidate.passwords) {
                callback(new Error('两次输入的密码不一致请重新输入'));
            } else {
                callback();
            }
        };
        return {
            logoimg: '', // logo
            bgimg: '', // 背景图
            tcpip: '', // 备案信息
            passwordValidate: { // 表单内容
                passwords: '', // 密码
                passwordcheck: '', // 确认密码
            },
            passwordRule: { // 表单验证
                passwords: [ // 密码
                    {validator: passwordsValidator, trigger: 'blur'}
                ],
                passwordcheck: [ // 确认密码
                    { validator: passwordcheckValidator, trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        getInfo () { // 获取数据
            axios({
                url: this.getWebsite() + api.logininfo + this.getCookie('cook_ShopId'),
                method: 'post'
            })
            .then(response => {
                if (response.status === 200) {
                    // console.log(response.data.msg)
                    this.logoimg = response.data.msg.baseinfo.orderinglogo
                    this.bgimg = response.data.msg.backgroundlist[0]
                    this.tcpip = response.data.msg.tcpip
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        submitInfo () { // 提交数据
            let data = {
                i_account: this.$route.params.phone,
                i_password: this.passwordValidate.passwords,
                i_repassword: this.passwordValidate.passwordcheck
            }
            axios({
                url: this.getWebsite() + api.setpassword + this.getCookie('cook_ShopId'),
                method: 'post',
                data: qs.stringify(data)
            })
            .then(response => {
                if (response.status === 200) {
                    // console.log(response.data)
                    if (!response.data.error) { // 密码修改成功
                        // 验证成功提示
                        console.log(123)
                        this.$Message.success('密码修改成功')
                        // 登录成功后跳转到指定页面
                        this.$router.push('/login')
                    } else { // 密码修改失败
                        this.$Message.error(response.data.msg)
                    }
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        handleSubmit (name) { // 点击登录按钮
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.submitInfo()
                }
            })
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.login_box {
    height: 580px;
    margin: -290px 0 0 -450px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/login/setpassword.vue